/* eslint-disable import/prefer-default-export */
export const getModalProperties = state => state.get('modal');
/* eslint-enable import/prefer-default-export */
